import Vue from 'vue';
import ChannelVideos from './ChannelVideos.vue';
export default Vue.extend({
    name: 'ChannelVideoSection',
    props: {
        videos: {
            type: Array,
        },
        title: String,
    },
    components: {
        ChannelVideos,
    },
});
